import { httpClient } from '../http/httpClient'

/**
 * `open` é o número do menu ("X chamados abertos"), `claimable` habilita o
 * "Atender próximo" e `mine`/`inProgress`/`all` são os badges das abas — esses
 * três contam só os pendentes. Todos já sem os direcionados ao WhatsApp.
 */
export interface SupportRequestCountsResponse {
  open: number
  claimable: number
  mine: number
  inProgress: number
  all: number
}

export async function getSupportRequestCounts() {
  const { data } = await httpClient.get<SupportRequestCountsResponse>(
    '/support-requests/stats/counts',
  )

  return data
}
